var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-n-filter"},[_c('div',[_vm._t("default")],2),_c('div',[_c('a',{staticClass:"chip",on:{"click":_vm.scrollToTop}},[_vm._v("To Top")])])])}
var staticRenderFns = []

export { render, staticRenderFns }